export const SET_PAYMENTS_LIST = 'SET_PAYMENTS_LIST';
export const SET_PAYMENT_DATA = 'SET_PAYMENT_DATA';
export const SET_FILTER_INITIAL_DATE = 'SET_FILTER_INITIAL_DATE';
export const SET_FILTER_FINAL_DATE = 'SET_FILTER_FINAL_DATE';
export const SET_FILTER_PAYMENT_INITIAL_DATE = 'SET_FILTER_PAYMENT_INITIAL_DATE';
export const SET_FILTER_PAYMENT_FINAL_DATE = 'SET_FILTER_PAYMENT_FINAL_DATE';
export const SET_FILTER_CARD_BRAND = 'SET_FILTER_CARD_BRAND';
export const SET_FILTER_TERMINAL_NUMBER = 'SET_FILTER_TERMINAL_NUMBER';
export const SET_FILTER_NSU_ACQUIRER = 'SET_FILTER_NSU_ACQUIRER';
export const SET_FILTER_OPERATION = 'SET_FILTER_OPERATION';
export const SET_FILTER_ORDINATION = 'SET_FILTER_ORDINATION';
export const SET_FILTER_STATUS = 'SET_FILTER_STATUS';
export const CURRENT_PAGE = 'CURRENT_PAGE';
export const SET_TOTAL_RESOURCES = 'SET_TOTAL_RESOURCES';
export const LIMIT_OPTIONS = 'LIMIT_OPTIONS';
export const LIMIT = 'LIMIT';
export const PAGE = 'PAGE';
export const LOADING_DATA = 'LOADING_DATA';
export const SET_PAYMENTS_SUBTOTAL = 'SET_PAYMENTS_SUBTOTAL';
export const SHOW_FILTERS = 'SHOW_FILTERS';
export const FILTER_PARAMS = 'FILTER_PARAMS';
export const FILTER_STATUS = 'FILTER_STATUS';
export const NEW_PAYMENT = 'NEW_PAYMENT';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const NEW_PAYMENT_STATUS = 'NEW_PAYMENT_STATUS';
export const NEW_PAYMENT_ERROR = 'NEW_PAYMENT_ERROR';
export const SET_FILTER_PARTNER = 'SET_FILTER_PARTNER';
export const SET_FILTER_MIN_AMOUNT = 'SET_FILTER_MIN_AMOUNT';
export const SET_FILTER_MAX_AMOUNT = 'SET_FILTER_MAX_AMOUNT';
export const LOAD_LIST = 'LOAD_LIST';
export const LOAD_LIST_SUBSCRIPTIONS = 'LOAD_LIST_SUBSCRIPTIONS';
export const LOAD = 'LOAD';
export const SUCCESS_STATUS = 'SUCCESS_STATUS';
export const ERROR_STATUS = 'ERROR_STATUS';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const GET_PAYMENT = 'GET_PAYMENT';
export const NEW_PAYMENT_RESPONSE = 'NEW_PAYMENT_RESPONSE';
